import styled from 'styled-components';
import { Input } from 'antd';

export const Hr = styled.div`
  display: block;
  width: 100%;
  height: 5px;
  background: rgba(0, 0, 0, 0.65);
  margin-bottom: 8px;
`;

export const TextAreaGrey = styled(Input.TextArea)`
  background: #d7d7d7 !important;
`;

export const InlineFormRow = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
  .ant-form-item-control-wrapper {
    display: inline-block;
  }
  .ant-form-item-label {
    min-width: 120px;
    text-align: left;
  }
  input {
    width: auto;
  }
`;

export const ContainerStyled = styled.div`
  &.new-work-operation {
    .ant-tabs-top-bar {
      display: none;
    }
  }
`;
